import { Helmet } from "react-helmet-async";

const BASE_URL = "https://teerjuwai.com";
const DEFAULT_TITLE = "Juwai Teer | Juwai Teer Result | Teer Result Today | Live FR & SR Results";
const OG_IMAGE = `${BASE_URL}/og-image.png`;

export default function SEO({ title, description, path = "/", noindex = false, jsonLd = null }) {
  const fullTitle = title || DEFAULT_TITLE;
  const canonical = `${BASE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta
        name="description"
        content={description || "Juwai Teer live FR and SR Teer results for all 21 games including Shillong, Khanapara, Bhutan and Guwahati. Updated daily with previous results and common numbers."}
      />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Juwai Teer" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Juwai Teer — Live Teer Results" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
